import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router'; // ✅ Import RouterModule
import {
  DsBreadcrumbModule,
  DsButtonModule,
  DsCheckboxModule,
  DsColumnData,
  DsFormFieldModule,
  DsIconModule,
  DsLoadingAreaConfiguration,
  DsLoadingAreaService,
  DsProgressCircleModule,
  DsRowData,
  DsSelectModule,
  DsTableModule,
  DsTabsModule,
  DsToastModel,
  DsToastService,
} from '@bmw-ds/components';
import { RequestPayload } from 'src/app/models/stock-search-payload.model';
import { CommonModule } from '@angular/common';
import { NatisDocsService } from '../../services/natis.service';
import {
  NatisDoc,
  NatisDocsRequest,
  NatisDocsResponse,
  NatisReleaseRequest,
} from 'src/app/models/natis-docs.model';
import { CrossBorderService } from '../../services/crossborder.service';
import { CosyUrlResponse } from '../../models/cosy.model';
import { FormsModule } from '@angular/forms';
import { UnitOverviewLinkPipe } from '../../unit-overview.pipe';

@Component({
  selector: 'app-natis-documents',
  imports: [
    CommonModule,
    DsIconModule,
    DsButtonModule,
    RouterModule,
    DsTabsModule,
    DsBreadcrumbModule,
    DsTableModule,
    DsSelectModule,
    DsFormFieldModule,
    DsCheckboxModule,
    DsProgressCircleModule,
    FormsModule,
    UnitOverviewLinkPipe,
  ],
  templateUrl: './natis-documents.component.html',
  styleUrl: './natis-documents.component.scss',
})
export class NatisDocumentsComponent implements OnInit {
  requestPayload!: RequestPayload;
  loadingAreaConfig: DsLoadingAreaConfiguration = { id: 'bodyLoading' , loadingTitle: 'Loading...'};
  columnData: DsColumnData[] = [
    // {
    //   field: 'image',
    //   headerName: 'Image',
    // },
    {
      field: 'model',
      headerName: 'Model',
    },
    {
      field: 'interior',
      headerName: 'Interior',
    },
    {
      field: 'exterior',
      headerName: 'Exterior',
    },
    {
      field: 'view',
      headerName: '',
    },
  ];
  rowsData: DsRowData[] = [];

  private readonly natisService = inject(NatisDocsService);
  private readonly stockService = inject(CrossBorderService);
  private readonly loadingAreaService = inject(DsLoadingAreaService);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly toastService = inject(DsToastService);

  ngOnInit(): void {
    this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);
    this.loadNatisDocs();
  }

  natisRows: DsRowData[] = [];

  private loadNatisDocs() {
    const requestPayload: NatisDocsRequest = {
      cNumber: localStorage.getItem('userId') || '',
      dealerCode: localStorage.getItem('dealerCode') || '',
    };
    console.log(requestPayload);
    this.natisService.getNatisDocs(requestPayload).subscribe({
      next: (data: NatisDocsResponse) => {
        console.log(data);

        this.natisRows = data.otab.map((item: NatisDoc) => ({
          image: '', // Placeholder for image URL
          model: item.zmodeldesc,
          interior: item.zint_desc,
          exterior: item.zext_desc,
          invoice: item.zinvoice,
          view: this.getReleaseStatus(item.zreleased),
          zvin: item.zvin, // Include VIN for fetching images later
          zreleased: item.zreleased,
        })); // Map to rows
        this.filteredRows = this.natisRows;
        this.cdr.detectChanges();
        // this.natisRows.forEach((row, idx) => {
        //   const cosyRequest = { VIN: row['zvin'] };
        //   this.stockService
        //     .getCosyUrl(cosyRequest)
        //     .subscribe((response: CosyUrlResponse) => {
        //       this.natisRows[idx]['image'] = response.exturl;
        //     });
        // });
      },
      error: (error: unknown) => {
        console.error('Error fetching NatisDocs data', error);
      },
      complete: () => {
        this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
        this.cdr.detectChanges();
      },
    });
  }

  getReleaseStatus(zreleased: string): string {
    switch (zreleased) {
      case 'X':
        return 'Released';
      case 'R':
        return 'NaTIS reported an Error';
      case 'Y':
        return 'NaTIS busy with Request';
      default:
        return 'Ready for Release';
    }
  }

  downloadDocument(vin: string | number): void {
    this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);
    const vinStr = String(vin);
    const bodyNo = vinStr.slice(-8);
    const requestPayload = { iv_vin: vinStr, iv_body: bodyNo };
    this.natisService.getNatisDocInfo(requestPayload).subscribe({
      next: (response) => {
        console.log('response', response);
        if (response.ev_pdf) {
          const byteCharacters = atob(response.ev_pdf);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: 'application/pdf' });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `${vinStr}.pdf`;
          a.click();
          window.URL.revokeObjectURL(url);
        }
      },
      error: (err) => {
        console.error('Download failed', err);
        this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
      },
      complete: () => {
        this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
        this.cdr.detectChanges();
      },
    });
  }

  releaseVehicle(rowElement: string | number) {
    this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);

    const request: NatisReleaseRequest = {
      cNumber: localStorage.getItem('userId') || '',
      dealerCode: localStorage.getItem('dealerCode') || '',
      vin: String(rowElement),
      zbody: String(rowElement).slice(-8),
    };
    this.natisService.releaseVehicle(request).subscribe({
      next: (response) => {
        console.log('Vehicle release response', response);
        if (response.error_code !== '' && response.error_code !== '00') {
          this.addToast(
            'critical',
            'Vehicle release failed: ' + response.message
          );
          return;
        }
        this.addToast('positive', response.message);
        this.loadNatisDocs();
      },
      error: (err) => {
        console.error('Vehicle release failed', err);
      },
      complete: () => {
        this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
        this.cdr.detectChanges();
      },
    });
  }

  addToast(tone: 'critical' | 'positive' | 'neutral', teastText: string): void {
    this.toastService.pushToast({
      id: 'error-toast',
      tone: tone,
      toastText: teastText,
    } as DsToastModel);
  }

  searchTerm: string = '';
  filteredRows: any[] = [];

  onSearch() {
    const term = this.searchTerm?.toLowerCase() || '';
    this.filteredRows = this.natisRows.filter((row) =>
      Object.values(row).some((val) =>
        val?.toString().toLowerCase().includes(term)
      )
    );
  }
}
